import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "../store/slices/auth";
import registerReducer from "./slices/register";
import planReducer from "./slices/plan";
import profileReducer from "./slices/profile";
import preferenceReducer from "./slices/preference";
import bookingReducer from "./slices/booking";
import IntrestedandShorlistedReducer from "./slices/intrestandshortlisted";
import visitorReducer from "./slices/visitor";
import ChatBotReducer from "./slices/chatbot";
import uiReducer from "./slices/ui";

const rootReducer = combineReducers({
  auth: authReducer,
  register: registerReducer,
  plan: planReducer,
  profile: profileReducer,
  preference: preferenceReducer,
  booking: bookingReducer,
  interestShortlist: IntrestedandShorlistedReducer,
  visitor: visitorReducer,
  chatbot: ChatBotReducer,
  ui: uiReducer,

});

const store = configureStore({
  reducer: rootReducer,
  devTools: true,
});
export default store;
